import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	withStyles,
	Grid,
	ExpansionPanel,
	ExpansionPanelSummary,
	Typography,
	ExpansionPanelDetails,
	Tooltip,
	IconButton,
} from '@material-ui/core'
import { ExpandMore, Info, Error } from '@material-ui/icons'
import classNames from 'classnames'
import styles from './styles'
// import SmartTaskField from './SmartTaskField'
import Name from './Name'
import { toggleGeneralPanel } from 'actions/tasks'
import Automation from './Automation'
import SelectedActionButtons from './SelectedActionButtons'
import language from 'utils/vast-languagepack'
import { last } from 'lodash'

export default connect(
	(state) => ({
		generalPanelExpanded: state.tasks.addOrEdit.generalPanelExpanded,
		actionTypePanelExpanded: state.tasks.addOrEdit.actionTypePanelExpanded,
		emailCardSelected: last(state.email.cardSelected),
	}),
	(dispatch) => bindActionCreators({ toggleGeneralPanel }, dispatch),
)(
	withStyles(styles)(
		({
			classes,
			toggleGeneralPanel,
			generalPanelExpanded,
			actionTypePanelExpanded,
			emailCardSelected,
		}) => {
			const Icon = generalPanelExpanded === 'error' ? Error : Info

			return (
				<ExpansionPanel
					classes={{ expanded: classes.expansionPanelExpanded }}
					style={
						emailCardSelected !== 'blank' ||
						(!Boolean(generalPanelExpanded) && actionTypePanelExpanded)
							? {
									borderRadius: 35,
									overflow: 'hidden',
							  }
							: !Boolean(generalPanelExpanded) && !actionTypePanelExpanded
							? {
									borderTopLeftRadius: 35,
									borderTopRightRadius: 35,
									borderBottomLeftRadius: 0,
									borderBottomRightRadius: 0,
									overflow: 'hidden',
							  }
							: null
					}
					expanded={Boolean(generalPanelExpanded)}
				>
					<ExpansionPanelSummary
						classes={{
							root: classes.expansionPanelSummary,
							expandIcon: classes.expandIcon,
							expanded: classes.expansionPanelSummaryExpanded,
						}}
						onClick={() => toggleGeneralPanel()}
						expandIcon={<ExpandMore />}
					>
						<Typography className={classes.heading}>
							{language.task.add.header.general}
						</Typography>
						<Tooltip title={language.task.add.toolTips.general}>
							<IconButton
								disableRipple
								style={{ padding: 0 }}
								className={classNames(
									classes.headingIcon,
									generalPanelExpanded === 'error'
										? classes.error
										: classes.color,
								)}
							>
								<Icon className={classes.icon} />
							</IconButton>
						</Tooltip>
					</ExpansionPanelSummary>
					<ExpansionPanelDetails>
						<Grid container spacing={24}>
							<Grid item xs={12}>
								<Name />
							</Grid>
							{/* <SmartTaskField /> */}
							<Grid item xs={12}>
								<SelectedActionButtons select />
							</Grid>
							<Automation />
						</Grid>
					</ExpansionPanelDetails>
				</ExpansionPanel>
			)
		},
	),
)
